import React, { Component } from 'react'
import { Row, Col } from 'antd'
import { app } from "../../app"
import '../../css/news-share.css'
import api from "../../api"

class NewsShare extends Component {
    constructor (props) {
        super(props)
        this.state = {
            news_id: props.match.params.id,
            dataInfo: {}
        }
    }

    componentDidMount () {
        this._isMounted = true
        window.document.title = '存心救援新闻'
        if (this.state.news_id) {
            this.handleDetail()
        }
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 详情
     */
    handleDetail = async () => {
        await this.setData({ loading: true})
        let state = { loading: false }
        let { flag, data, msg } = await app.post(api.NewNewsDetails, {
            id: this.state.news_id,
            request: 'news',
        })
        if (flag === 1) {
            window.document.title = data.news_title
            state.dataInfo = data
        } else {
            app.alert(msg, 'error')
        }
        await this.setData(state)
    }

    setData = (data) => app.setStateSync(this, data)

    render () {
        return (
            <div className="news-share">
                <img src="https://tp.blueskyrescue.cn/Uploads/News/20190321/thumb_5c92fa9146298.jpg"/>
            </div>
        )
    }
}

export default NewsShare



// WEBPACK FOOTER //
// ./src/routes/other/NewsShare.jsx